import { Dialog } from '@ori-ui/components';
import { Button, Grid } from '@ori-ui/mui';
import { FormatCurrency } from '@ori/culture-provider';
import { type FC } from 'react';

import { AppContextProvider } from '../contexts';
import { useLoyaltyDialog } from '../hooks';
import { BuyForPointsButton } from './BuyForPointsButton';
import { DialogContent } from './DialogContent';
import { DialogHeader } from './DialogHeader';

export const LoyaltyDialog: FC = () => {
  const { data, handleBuyForMoney, handleBuyForPoints, handleClose } = useLoyaltyDialog();

  if (!data) {
    return null;
  }

  return (
    <AppContextProvider value={data}>
      <Dialog
        open
        onClose={handleClose}
      >
        <>
          <DialogHeader points={data.loyaltyPoints} />
          <DialogContent
            actions={
              <Grid
                container
                direction="column"
                spacing={3}
              >
                <Grid item>
                  <BuyForPointsButton onClick={handleBuyForPoints} />
                </Grid>
                <Grid item>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onClick={handleBuyForMoney}
                  >
                    <FormatCurrency>{data.consultantPrice ?? 0}</FormatCurrency>
                  </Button>
                </Grid>
              </Grid>
            }
          />
        </>
      </Dialog>
    </AppContextProvider>
  );
};
